export default __webpack_public_path__ + "img/empty_created_perks-3187143e54151d81f091fd9cedf0ca63.png";